import * as service from './service'
export default {
  namespace: 'recommendMessengerInvitationRecord',
  state: {
    demoData: {}
  },
  effects: {
    * getRecommendData ({ payload }, { call, put }) {
      try {
        const res = yield call(service.getRecommendData, payload)
        if (res.data.status !== 200) {
          console.error(res.data.err)
        }
        return res.data.data
      } catch (err) {
        console.log(err, 'errrrrrr')
        return err
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
